import { requestOrphanJustification } from '@/components/billing/orphan-pix-match-dialog'
import { markBillingAsPaid } from '@/lib/api/financial/financial-billing-api'

/**
 * Baixa manual com a checagem de Pix sem vínculo.
 *
 * Se já entrou um Pix solto de mesmo valor, o backend recusa com `ORPHAN_PIX_MATCH`; aqui
 * o diálogo pergunta o motivo e a baixa é refeita com ele. Desistindo, a baixa não
 * acontece e a mensagem orienta a vincular o Pix. Use no lugar de `markBillingAsPaid` em
 * toda tela que dá baixa.
 */
export async function markBillingAsPaidChecked(
    id: number,
    data?: { paidAmount?: number; paidAt?: string },
): ReturnType<typeof markBillingAsPaid> {
    const response = await markBillingAsPaid(id, data)
    if (response.success || response.errorCode !== 'ORPHAN_PIX_MATCH') return response

    const note = await requestOrphanJustification(response.error || 'Já entrou um Pix deste valor sem vínculo.')
    if (!note) {
        return {
            ...response,
            error: 'Baixa não registrada. Se o pagamento é o Pix que já entrou, vincule-o em "Pagamentos sem vínculo".',
        }
    }
    return markBillingAsPaid(id, { ...data, orphanCheckNote: note })
}
